import { User2 } from "lucide-react";
import { useSignUpDate } from "../hooks/useSignUpDate";
import { SignUpDateProps } from "../@types/props.types";
import s from "../styles/modules/SignUp.module.scss";

const SignUpDate = ({ date, trainers, slots }: SignUpDateProps) => {
  const { trainersNames } = useSignUpDate(date, trainers, slots);

  return (
    <div className="flex items-center text-left text-sm">
      <div className="flex">
        {trainersNames.length > 0 ? (
          <>
            <div className="flex items-center gap-2">
              <div className={`rounded-full bg-primary/10 p-2 ${s.icon_of_trainer}`}>
                <User2 className="icon h-5 w-5 transition-colors duration-200" />
              </div>
              <div className="text-left">
                <div className={trainersNames.length > 1 ? "flex flex-col gap-1" : ""}>
                  {trainersNames.map((trainer, index) => (
                    <div key={index} className="font-normal text-gray-700">
                      {trainer}
                      {index + 1 !== trainersNames.length && trainersNames.length > 1 && ","}
                      {index + 1 === trainersNames.length && trainersNames.length > 1 && "."}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="text-left text-gray-500">Нет доступных тренеров</div>
        )}
      </div>
    </div>
  );
};

export default SignUpDate;
